<template>
  <div class="position-relative w-100">
    <textarea
      v-bind="$attrs"
      ref="input"
      v-model="modelValue"
      :disabled="props.disabled"
      :placeholder="placeholder ? $t(placeholder) : null"
    />
    <span v-if="language" style="position: absolute; right: 12px; top: 11px" :class="`fi fi-${getFlagCode({ code })}`"/>
  </div>
</template>

<script setup>
  import { ref, watch, nextTick, computed } from 'vue';
  import { getFlagCode } from '@/utils/language';

  const props = defineProps({
    modelValue: {
      required: false,
      type: null,
      default: '',
    },
    autoResize: {
      type: Boolean,
      required: false,
      default: true,
    },
    disabled: {
      type: Boolean,
      required: false,
      default: false,
    },
    placeholder: {
      type: null,
      default: null,
    },
    language: {
      type: Object,
      default: null,
    },
  });

  defineOptions({
    inheritAttrs: false,
  });

  const emit = defineEmits(['update:modelValue']);

  const input = ref(null);

  const modelValue = computed({
    get: () => props.modelValue,
    set: (value) => emit('update:modelValue', value),
  });

  const code = computed(() => {
    if (props.language.code === 'en') {
      return 'gb';
    }

    return props.language.code;
  });

  watch(() => props.modelValue, () => {
    if (props.autoResize) {
      nextTick(() => {
        resize();
      });
    }
  }, { immediate: true });


  function resize() {
    const el = input.value;
    el.style.height = 'auto';
    el.style.height = `${el.scrollHeight}px`;
  }

  defineExpose({ input });
</script>
